const masterchefv2 = require("./masterchef_v2");

module.exports = {
  UNIV2_ROUTER_ADDRESS: "0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3",
  FARMS: {
    masterchefv2
  },
};
